import { render, staticRenderFns } from "./zfield.vue?vue&type=template&id=5fbdf8ac&scoped=true"
import script from "./zfield.vue?vue&type=script&lang=js"
export * from "./zfield.vue?vue&type=script&lang=js"
import style0 from "./zfield.vue?vue&type=style&index=0&id=5fbdf8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbdf8ac",
  null
  
)

export default component.exports